import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell, faClipboardList, faExternalLinkAlt, faTable } from '@fortawesome/free-solid-svg-icons'
import { viewPath } from 'helpers/utils'

const KINDS = {
  view: { label: 'View', icon: faTable, href: (link) => viewPath(link.section_name, link.dashboard_id) },
  sample: { label: 'Sample', icon: faClipboardList, href: (link) => link.source_id && `/samples/${link.source_id}` },
  analytic: { label: 'Analytic', icon: faBell, href: (link) => link.analytic_id && `/analytics/${link.analytic_id}` }
}

export const createdHref = (link) => KINDS[link?.kind]?.href(link) || ''

// Something the assistant created or pulled in, shown as a card that opens it in a new tab.
const CreatedCard = ({ link, wrap = false }) => {
  const kind = KINDS[link.kind]
  const href = createdHref(link)
  if (!kind || !href) return null

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="d-flex align-items-center gap-3 border rounded-3 px-3 py-2 mb-2 bg-white text-decoration-none text-primary"
      style={{ maxWidth: 480 }}
      data-testid="ask-created"
    >
      <FontAwesomeIcon icon={kind.icon} className="text-info" fixedWidth />
      <span className={`flex-grow-1 ${wrap ? 'text-break' : 'text-truncate'}`}>
        <span className={`d-block fw-semibold ${wrap ? '' : 'text-truncate'}`}>{link.title}</span>
        <span className="d-block small text-muted">
          {kind.label}
          {link.section_name ? ` · ${link.section_name}` : ''}
        </span>
      </span>
      <FontAwesomeIcon icon={faExternalLinkAlt} className="text-muted small" />
    </a>
  )
}

export default CreatedCard
